function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { processImageUrl } from './utils/imageUrlProcessor';
import { createBlobUrl, revokeBlobUrl } from './utils/blobManager';
import { getDefaultImagePath } from './utils/sourceResolver'; // resolveImageSource는 사용 안 함
export default function useImageDisplay(param) {
    var src = param.src, onError = param.onError, fallbackSrc = param.fallbackSrc, imageBlob = param.imageBlob;
    var _useState = _sliced_to_array(useState('idle'), 2), status = _useState[0], setStatus = _useState[1];
    var _useState1 = _sliced_to_array(useState(''), 2), currentSrcToLoad = _useState1[0], setCurrentSrcToLoad = _useState1[1];
    var _useState2 = _sliced_to_array(useState(0), 2), currentAttemptIndex = _useState2[0], setCurrentAttemptIndex = _useState2[1]; // 0: primary, 1: fallback1, 2: fallback2
    var _useState3 = _sliced_to_array(useState(false), 2), fadeIn = _useState3[0], setFadeIn = _useState3[1];
    var imgRef = useRef(null);
    var internalBlobUrlRef = useRef(null);
    var hasCalledOnErrorRef = useRef(false);
    var log = useMemo(function() {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
        };
    }, []);
    var defaultFallbackImage = useMemo(function() {
        return getDefaultImagePath();
    }, []);
    log('기본 정적 fallback 이미지 경로:', defaultFallbackImage);
    var processUrl = useCallback(function(url) {
        var blobUrl = internalBlobUrlRef.current;
        return processImageUrl(url, {
            internalBlobUrl: blobUrl,
            imageBlob: imageBlob,
            log: log
        });
    }, [
        imageBlob
    ]);
    // Potential sources in order of preference
    var sources = useMemo(function() {
        log('[useImageDisplay] sources 계산 시작:', {
            src: src,
            fallbackSrc: fallbackSrc
        });
        var _internalBlobUrlRef_current;
        var primary = (_internalBlobUrlRef_current = internalBlobUrlRef.current) !== null && _internalBlobUrlRef_current !== void 0 ? _internalBlobUrlRef_current : src && src.trim() !== '' ? processUrl(src) : null;
        var fallback1 = fallbackSrc && fallbackSrc.trim() !== '' ? processUrl(fallbackSrc) : null;
        var fallback2 = defaultFallbackImage;
        log('[useImageDisplay] 계산된 소스:', {
            primary: primary,
            fallback1: fallback1,
            fallback2: fallback2
        });
        var validSources = [
            primary,
            fallback1,
            fallback2
        ].filter(function(s) {
            return s && s.trim() !== '';
        });
        log('[useImageDisplay] 유효한 최종 sources 배열:', validSources);
        return validSources;
    }, [
        src,
        fallbackSrc,
        imageBlob,
        processUrl,
        defaultFallbackImage,
        internalBlobUrlRef.current,
        log
    ]); // log 추가
    // Blob URL logic
    useEffect(function() {
        var newBlobUrl = null;
        if (_instanceof(imageBlob, Blob)) {
            log('imageBlob 변경됨, 새 Blob URL 생성 시도');
            if (internalBlobUrlRef.current) {
                revokeBlobUrl({
                    url: internalBlobUrlRef.current,
                    log: log
                });
            }
            newBlobUrl = createBlobUrl(imageBlob, log);
            internalBlobUrlRef.current = newBlobUrl;
        }
        return function() {
            if (newBlobUrl) {
                revokeBlobUrl({
                    url: newBlobUrl,
                    log: log
                });
                if (internalBlobUrlRef.current === newBlobUrl) {
                    internalBlobUrlRef.current = null;
                }
            }
        };
    }, [
        imageBlob,
        log
    ]);
    // Reset logic when primary sources change
    useEffect(function() {
        log('Source props changed, resetting', {
            src: src,
            fallbackSrc: fallbackSrc,
            imageBlob: imageBlob
        });
        setStatus('idle');
        setCurrentAttemptIndex(0);
        setCurrentSrcToLoad('');
        setFadeIn(false);
        hasCalledOnErrorRef.current = false;
    }, [
        src,
        fallbackSrc,
        imageBlob
    ]);
    // Load image logic
    useEffect(function() {
        log("[useImageDisplay] 로딩 Effect 실행: status=".concat(status, ", attemptIndex=").concat(currentAttemptIndex));
        if (status === 'idle') {
            log("Effect [status=idle]: sources 확인 (길이 ".concat(sources.length, ")"), JSON.stringify(sources));
            if (sources.length > currentAttemptIndex) {
                var initialSrc = sources[currentAttemptIndex];
                log('Setting initial src to load (setCurrentSrcToLoad 호출 전):', initialSrc);
                // --- 임시 지연 추가 ---
                var timer = setTimeout(function() {
                    log('임시 지연 후 로딩 시작');
                    setCurrentSrcToLoad(initialSrc);
                    setStatus('loading');
                    log('State update: src 설정, status=loading');
                }, 300); // 300ms 지연
                // 클린업 함수 추가
                return function() {
                    return clearTimeout(timer);
                };
            // --- 지연 추가 끝 ---
            } else {
                log('No valid sources found at index 0, setting to failed');
                setStatus('failed');
            }
        }
    }, [
        status,
        currentAttemptIndex,
        sources,
        log
    ]);
    // Fade-in logic
    useEffect(function() {
        log("[useImageDisplay] FadeIn Effect 실행: status=".concat(status, ", fadeIn=").concat(fadeIn));
        var timer;
        if (status === 'loaded' && !fadeIn) {
            // ***** 로그 추가: fadeIn 업데이트 시도 *****
            log('Status is loaded and fadeIn is false, attempting to set fadeIn=true after delay');
            // 이미지가 DOM에 렌더링될 시간을 약간 준 후 fade-in 시작
            timer = setTimeout(function() {
                log('setTimeout 완료, setFadeIn(true) 호출');
                setFadeIn(true);
            }, 50); // 50ms 지연
        } else if (status !== 'loaded' && fadeIn) {
            // ***** 로그 추가: fadeIn 리셋 시도 *****
            log('Status is not loaded but fadeIn is true, resetting fadeIn=false');
            // 이미지 소스가 변경되거나 로딩 실패 시 fade-in 상태 리셋
            setFadeIn(false);
        }
        return function() {
            if (timer) {
                log('FadeIn Effect cleanup: 타이머 클리어');
                clearTimeout(timer);
            }
        };
    }, [
        status,
        fadeIn,
        log
    ]); // 의존성에 fadeIn 추가 및 log 추가
    // Load success handler
    var handleLoad = useCallback(function() {
        if (status === 'loading') {
            log('Load success:', currentSrcToLoad);
            setStatus('loaded');
        }
    }, [
        status,
        currentSrcToLoad
    ]);
    // Load error handler
    var handleError = useCallback(function() {
        if (status === 'loading') {
            var failedSrc = currentSrcToLoad;
            log("Load failed for attempt ".concat(currentAttemptIndex, ":"), failedSrc);
            if (!hasCalledOnErrorRef.current) {
                onError === null || onError === void 0 ? void 0 : onError();
                hasCalledOnErrorRef.current = true;
            }
            var nextAttemptIndex = currentAttemptIndex + 1;
            log("Checking next source availability: nextIndex=".concat(nextAttemptIndex, ", sources.length=").concat(sources.length));
            if (nextAttemptIndex < sources.length) {
                var nextSrcToLoad = sources[nextAttemptIndex];
                log("Trying next source (index ".concat(nextAttemptIndex, "):"), nextSrcToLoad);
                setCurrentAttemptIndex(nextAttemptIndex);
                setCurrentSrcToLoad(nextSrcToLoad);
                setStatus('loading');
                log('State update: attemptIndex incremented, next src set, status set to loading');
            } else {
                log('All sources failed.');
                setStatus('failed');
            }
        } else {
            log("Error occurred but status is not 'loading' (status: ".concat(status, "), ignoring."));
        }
    }, [
        status,
        currentAttemptIndex,
        currentSrcToLoad,
        sources,
        onError,
        log
    ]);
    return {
        imgRef: imgRef,
        currentSrcToLoad: currentSrcToLoad,
        status: status,
        fadeIn: fadeIn,
        handleLoad: handleLoad,
        handleError: handleError,
        log: log,
        currentAttemptIndex: currentAttemptIndex
    };
}
